define([
    'text!product-detail/page/grocery-page-content.html',
    // 'product-detail/grocery/knowledge-info',
    // 'product-detail/component/more-products',
    // 'product-detail/grocery/maintain-info',
    // 'product-detail/component/scene-list',
    // 'product-detail/component/sku-info',
    // 'product-detail/component/spec-info',
    // 'product-detail/grocery/brand-info',
    // 'product-detail/component/dimension-table',
    // 'product-detail/component/feature-list'

    'product-detail/furniture/knowledge-info-new',
    'product-detail/component/more-products',
    'product-detail/component/next-product',
    'product-detail/furniture/maintain-info',
    'product-detail/component/scene-list-new',
    'product-detail/component/sku-info-new',
    'product-detail/component/spec-info-new',
    'product-detail/furniture/design-info-new',
    'product-detail/furniture/material-list-new',
    'product-detail/component/dimension-table',
    'product-detail/component/feature-list'
], function(
    tpl,
    // KnowledgeInfo,
    // MoreProducts,
    // MaintainInfo,
    // SceneList,
    // SkuInfo,
    // SpecInfo,
    // BrandInfo,
    // DimensionTable,
    // FeatureList

    KnowledgeInfo,
    MoreProducts,
    NextProduct,
    MaintainInfo,
    SceneList,
    SkuInfo,
    SpecInfo,
    DesignInfo,
    MaterialList,
    DimensionTable,
    FeatureList
){
    return {
        template: tpl,
        components: {
            // KnowledgeInfo: KnowledgeInfo,
            // MoreProducts: MoreProducts,
            // MaintainInfo: MaintainInfo,
            // SceneList: SceneList,
            // SkuInfo: SkuInfo,
            // SpecInfo: SpecInfo,
            // BrandInfo: BrandInfo,
            // DimensionTable: DimensionTable,
            // FeatureList: FeatureList

            KnowledgeInfo: KnowledgeInfo,
            MoreProducts: MoreProducts,
            NextProduct: NextProduct,
            MaintainInfo: MaintainInfo,
            SceneList: SceneList,
            SkuInfo: SkuInfo,
            SpecInfo: SpecInfo,
            DesignInfo: DesignInfo,
            MaterialList: MaterialList,
            DimensionTable: DimensionTable,
            FeatureList: FeatureList
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/page/grocery-page-content.js
// module id = 305
// module chunks = 0